/* eslint-disable react/prop-types */
import classes from "./reserch-form.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import SelectableList from "@/components-library/widgets/selectable-list";
import classNames from "classnames";

const NONE_ITEMS = 0;
const REGION_PLACEHOLDER = "Seleziona la regione";

function ReserchForm({
  selectedRegion,
  selectedCities,
  regions,
  cities,
  onCitySelect,
  onRegionSelect,
  onClick,
  isRegionFilterUsed,
  isCitiesFilterUsed,
}) {
  var isCitiesListEnabled = cities?.length > NONE_ITEMS;
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Flex
      align="center"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <Label tag="h1" weight="bold" align="center" className={classes.title}>
        Bandi per le aziende
      </Label>

      <Label tag="h4" weight="bold" align="center" className={classes.subtitle}>
        {
          "Compila i campi richiesti per visualizzare\ni bandi adatti alla tua azienda"
        }
      </Label>

      <Flex
        align={isMobile ? "center" : "flex-start"}
        direction={isMobile ? "column" : "row"}
        justify="center"
        className={classes.listContainer}
      >
        <SelectableList
          title="Regione*"
          list={regions}
          value={selectedRegion.name}
          onItemSelect={onRegionSelect}
          isEnabled={regions.length}
          isMultiSelect={false}
          className={classes.list}
          headerClassName={classNames({
            [classes.headerValid]: isRegionFilterUsed,
          })}
        />
        <SelectableList
          title="Provincia"
          list={cities}
          value={selectedCities}
          onItemSelect={onCitySelect}
          isEnabled={isCitiesListEnabled}
          isMultiSelect={true}
          className={classNames(classes.list, {
            [classes.disabled]: !isCitiesListEnabled,
          })}
          headerClassName={classNames({
            [classes.headerValid]: isCitiesFilterUsed,
          })}
        />
      </Flex>

      <Label tag="p" align="start" className={classes.notes}>
        I campi contrassegnati da asterisco (*) sono obbligatori
      </Label>

      <Button
        onClick={onClick}
        size="sm"
        color="primary"
        isEnabled={selectedRegion?.name !== REGION_PLACEHOLDER}
        className={classes.button}
      >
        TROVA I BANDI
      </Button>
      <Label tag="p" align="start" className={classes.disclaimer}>
        All’interno delle schede riassuntive dei bandi sarà possibile verificare
        la cumulabilità dell’incentivo con altre agevolazioni
      </Label>
    </Flex>
  );
}

export default ReserchForm;
